export default [{"url":"https://hayzedd-test8-0.api.invexerp.io","name":"Branch 1","port":"5037","isStore":true,"isHQ":true}]